var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTabOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 7.16042V8.81563C8.88889 8.85625 8.8559 8.88889 8.81563 8.88889H1.18438C1.14375 8.88889 1.11111 8.8559 1.11111 8.81563V1.18438C1.11111 1.14375 1.1441 1.11111 1.18438 1.11111H2.83958C2.99722 1.11111 3.125 0.983333 3.125 0.825695V0.285417C3.125 0.127778 2.99722 0 2.83958 0H0.564583C0.252778 0 0 0.252778 0 0.564583V9.43542C0 9.74722 0.252778 10 0.564583 10H9.43542C9.74722 10 10 9.74722 10 9.43542V7.16042C10 7.00278 9.87222 6.875 9.71458 6.875H9.17431C9.01667 6.875 8.88889 7.00278 8.88889 7.16042Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.285417V0.825695C5 0.983333 5.12778 1.11111 5.28542 1.11111H8.10313L3.55417 5.66007C3.44549 5.76875 3.44549 5.94549 3.55417 6.05417L3.94583 6.44583C4.05451 6.55451 4.23125 6.55451 4.33993 6.44583L8.88889 1.89688V4.71458C8.88889 4.87222 9.01667 5 9.17431 5H9.71458C9.87222 5 10 4.87222 10 4.71458V0.557986C10 0.249653 9.75 0 9.44201 0H5.28576C5.12812 0 5.00035 0.127778 5.00035 0.285417H5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTabOpenIcon);
export default __webpack_public_path__ + "static/media/NewTabOpenIcon.ad9d52195fbc10d7a86e8be220416cf6.svg";
export { ForwardRef as ReactComponent };